import { app as api } from '@ekuaibao/whispered'

const SAFE_SETTING = '@safeSetting-old'

export default [
  {
    id: SAFE_SETTING,
    path: '/safe-setting-old',
    ref: '/',
    onload: () => import('./safeSetting-view'),
    store: () => import('./safeSetting.store')
  },
  {
    point: '@@layers',
    prefix: SAFE_SETTING,
    onload: () => [
      {
        key: 'FactorAuthRiskModal',
        getComponent: () => import('./FactorAuthRiskModal'),
        title: '',
        width: 600
      }]
  },
  {
    point: '@@menus',
    onload: () => {
      return [
        {
          id: 'safeSetting-old',
          pId: 'baseSetting',
          permissions: ['SYS_ADMIN'],
          weight: 15,
          label: i18n.get('协助'),
          href: '/safe-setting-old',
        }
      ]
    }
  }
]